import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Ionicons } from '@expo/vector-icons';
import * as Font from 'expo-font';
import AsyncStorage from '@react-native-async-storage/async-storage';

import Router from './Router';

import * as Actions from '../store/Actions';
import { wrapper } from '../utils/asyncFunctions';
import { getToken } from '../utils/token';
import EmptyScreen from '../screens/EmptyScreen';

class MainContainer extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor() {
    super();
    this.state = {
      token: null,
      assetsLoaded: false,
      registrationError: null,
    };
  }

  componentDidMount = async () => {
    const { actions } = this.props;
    // const [tError] = await wrapper(AsyncStorage.removeItem("token"));
    // if (firebase.apps && firebase.apps.length) {
    //   firebase.app(); // if already initialized, use that one
    // } else {
    //   firebase.initializeApp(appJson.expo.web.config.firebase);
    // }

    // Load fonts
    try {
      await Font.loadAsync({
        ...Ionicons.font,
        'roboto-regular': {
          uri: require('../assets/fonts/Roboto-Regular.ttf'),
          display: 'swap',
        },
        'roboto-bold': {
          uri: require('../assets/fonts/Roboto-Bold.ttf'),
          display: 'swap',
        },
        Roboto: {
          uri: require('../assets/fonts/Roboto-Regular.ttf'),
          display: 'swap',
        },
      });
    } catch (e) {
      // Safari FontObserver timeout after 3000ms, this will fail silently
    }

    // Get token and session ID
    const [error, token] = await wrapper(getToken());
    if (error) console.log('MainContainer:componentDidMount', { error });
    if (token) this.login(token);
    this.setState({ token, assetsLoaded: true });

    // get stored language, if any
    const languageIndex = await AsyncStorage.getItem('language');
    if (languageIndex) actions.selectLanguage(languageIndex);
  };

  componentDidUpdate() {
    const { token, registrationError } = this.state;
    const { registration } = this.props;
    if (registration.token !== token) {
      this.setState({ token: registration.token });
      if (registration.token) {
        this.login(registration.token);
      }
    }
    if (!registrationError && registration.error) {
      const { error } = registration;
      const errorString = error.message || error.toString();
      console.log(errorString);
      this.setState({ registrationError: errorString });
    }
  }

  login = (token) => {
    const { actions } = this.props;
    actions.login(token);
  };

  render() {
    const { assetsLoaded } = this.state;
    const { registration } = this.props;

    if (!assetsLoaded) {
      return <EmptyScreen />;
    }

    return <Router registration={registration} />;
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
